import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ListarServicosState } from "../../reducers/Servicos/servicos-jornal.reducer";

export const selectListarServicosState = createFeatureSelector<ListarServicosState>('listarServicos');

export const selectDadosListarServicos = createSelector(
  selectListarServicosState,
  (state: ListarServicosState) => state.response
);

export const selectListarServicos = createSelector(
  selectListarServicosState,
  (state: ListarServicosState) => state
);

export const selectErrosListarServicos = createSelector(
  selectListarServicosState,
  (state: ListarServicosState) => state.error
);
